import React from "react";

/* Common */
import Button from "../../common/Button";

/* Components */
import { Modal } from '~/components/common';

/* Utilities */
import { trans } from '~/utilities';

export default function PosessionModal({ detachUrl, modalOpen, setModalOpen }) {
    return (
        <Modal
            open={modalOpen}
            className="modal--extranet-small"
            handleClose={() => setModalOpen(false)}
            backText=""
            modalTitle={trans('app.extranet.vehicle_detail.posession_modal_title')}
            modalBody={
                <div className="row">
                    <div className="col-12">
                        <h5 className="mb-1">{trans('app.extranet.vehicle_detail.posession_modal_label')}</h5>
                        <p className="text-muted--60">{trans('app.extranet.vehicle_detail.posession_modal_text')}</p>
                        <form action={detachUrl} method="POST">
                            <div className="custom-control custom-checkbox mt-2">
                                <input
                                    id="approve"
                                    className="custom-control-input"
                                    type="checkbox"
                                    name="approve"
                                    required={true}
                                />
                                <label className="custom-control-label text--default" htmlFor="approve">
                                    <span className="font-weight-medium">{trans('app.extranet.vehicle_detail.posession_modal_checkbox')}</span>
                                </label>
                            </div>
                            <Button theme="secondary" className="btn-block-sm mt-3" type="submit" title={trans('app.extranet.vehicle_detail.posession_modal_button')} onClick={() => {}} />
                        </form>
                    </div>
                </div>
            }
        />
    );
}
